import {Button, TableBody, TableContainer, TableHead, Typography} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {TagChip} from 'presentation/components';

import {
	ACTIONS,
	FIRST_ACTION_TARGET_ID,
	STATUS_BADGE_META,
	TABLE_COLUMNS,
	TABLE_FOOTER_NOTE,
} from '../../constants';
import {
	Card,
	StyledTable,
	StyledTableBodyRow,
	StyledTableCell,
	StyledTableHeadRow,
} from '../../styles';
import {RefundDocumentStatusEnum, RefundDocumentTableProps} from '../../types';

export function SendDocumentsTable({rows, onSendDocument, onOpenAttachment}: RefundDocumentTableProps) {
	return (
		<Card>
			<TableContainer>
				<StyledTable>
					<TableHead>
						<StyledTableHeadRow>
							<StyledTableCell>{TABLE_COLUMNS.status}</StyledTableCell>
							<StyledTableCell>{TABLE_COLUMNS.documento}</StyledTableCell>
							<StyledTableCell>{TABLE_COLUMNS.obrigatorio}</StyledTableCell>
							<StyledTableCell>{TABLE_COLUMNS.dataEnvio}</StyledTableCell>
							<StyledTableCell>{TABLE_COLUMNS.anexo}</StyledTableCell>
							<StyledTableCell align="right" />
						</StyledTableHeadRow>
					</TableHead>
					<TableBody>
						{rows.map((row, index) => {
							const badge = STATUS_BADGE_META[row.status];
							const isUnsent = row.status === RefundDocumentStatusEnum.PENDENTE;
							const actionLabel = isUnsent
								? ACTIONS.sendDocument
								: ACTIONS.replaceDocument;
							const isFirstRow = index === 0;

							return (
								<StyledTableBodyRow key={row.id}>
									<StyledTableCell>
										<TagChip label={badge.label} color={badge.color} />
									</StyledTableCell>
									<StyledTableCell>
										<Typography variant="body2">{row.documento}</Typography>
									</StyledTableCell>
									<StyledTableCell>
										{row.obrigatorio ? (
											<Icon name="check-default" size={20} />
										) : null}
									</StyledTableCell>
									<StyledTableCell>
										<Typography variant="body2">
											{row.dataEnvio ?? '-'}
										</Typography>
									</StyledTableCell>
									<StyledTableCell>
										{row.anexo ? (
											<Button
												type="button"
												variant="text"
												size="small"
												onClick={() => onOpenAttachment(row)}
												endIcon={
													<Icon
														name="external-link-default"
														size={16}
													/>
												}>
												{ACTIONS.viewDocument}
											</Button>
										) : (
											<Typography variant="body2">-</Typography>
										)}
									</StyledTableCell>
									<StyledTableCell align="right">
										<Button
											id={isFirstRow ? FIRST_ACTION_TARGET_ID : undefined}
											type="button"
											variant="outlined"
											size="small"
											sx={{borderRadius: 9999}}
											onClick={() => onSendDocument(row)}>
											{actionLabel}
										</Button>
									</StyledTableCell>
								</StyledTableBodyRow>
							);
						})}
					</TableBody>
				</StyledTable>
			</TableContainer>
			<Typography variant="caption" color="text.secondary">
				{TABLE_FOOTER_NOTE}
			</Typography>
		</Card>
	);
}
